/*
 * Homepage campaign calendar.
 *
 * This is intentionally a small, checked-in source of truth rather than a
 * browser-side fixture API. Update these windows when official schedules move.
 * All timestamps are explicit UTC values so the selector behaves consistently
 * across devices and around UK daylight-saving changes.
 */

const PREMIER_LEAGUE_SOURCE = 'Premier League official 2026/27 fixture calendar';
const UEFA_SOURCE = 'UEFA official 2026/27 Champions League calendar';
const FIFA_SOURCE = 'FIFA international match calendar 2026-2030';
const TRANSFER_SOURCE = 'Premier League official 2026 summer / 2027 winter window dates';

export const HOMEPAGE_CALENDAR_EVENTS = [
  {
    id: 'transfer-window-summer-2026',
    eventType: 'transfer-window',
    flagshipId: 'transfer-window-challenge',
    startsAt: '2026-06-15T00:00:00Z',
    endsAt: '2026-09-02T00:00:00Z',
    label: 'Summer transfer window',
    sourceNote: TRANSFER_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'transfer-deadline-summer-2026',
    eventType: 'transfer-deadline',
    flagshipId: 'transfer-window-challenge',
    startsAt: '2026-08-25T00:00:00Z',
    endsAt: '2026-09-03T00:00:00Z',
    label: 'Summer deadline day',
    sourceNote: TRANSFER_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'premier-league-opening-matchday-2026',
    eventType: 'domestic-league',
    flagshipId: 'thirty-eight-zero',
    startsAt: '2026-08-20T00:00:00Z',
    endsAt: '2026-08-25T12:00:00Z',
    label: 'Premier League opening matchday',
    sourceNote: PREMIER_LEAGUE_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'premier-league-matchday-2-2026',
    eventType: 'domestic-league',
    flagshipId: 'thirty-eight-zero',
    startsAt: '2026-08-27T00:00:00Z',
    endsAt: '2026-09-02T12:00:00Z',
    label: 'Premier League matchday',
    sourceNote: PREMIER_LEAGUE_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-matchday-1-2026',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2026-09-06T00:00:00Z',
    endsAt: '2026-09-12T00:00:00Z',
    label: 'Champions League matchday 1',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'international-break-september-2026',
    eventType: 'international-break',
    flagshipId: 'world-xi-cup',
    startsAt: '2026-09-23T00:00:00Z',
    endsAt: '2026-10-08T00:00:00Z',
    label: 'International window',
    sourceNote: FIFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-matchdays-2-and-3-2026',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2026-10-11T00:00:00Z',
    endsAt: '2026-10-24T00:00:00Z',
    label: 'Champions League matchdays 2-3',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'international-break-november-2026',
    eventType: 'international-break',
    flagshipId: 'world-xi-cup',
    startsAt: '2026-11-08T00:00:00Z',
    endsAt: '2026-11-19T00:00:00Z',
    label: 'International window',
    sourceNote: FIFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-matchday-4-2026',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2026-11-03T00:00:00Z',
    endsAt: '2026-11-05T00:00:00Z',
    label: 'Champions League matchday 4',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-matchday-5-2026',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2026-11-24T00:00:00Z',
    endsAt: '2026-11-26T00:00:00Z',
    label: 'Champions League matchday 5',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-matchday-6-2026',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2026-12-06T00:00:00Z',
    endsAt: '2026-12-12T00:00:00Z',
    label: 'Champions League matchday 6',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'transfer-window-winter-2027',
    eventType: 'transfer-window',
    flagshipId: 'transfer-window-challenge',
    startsAt: '2027-01-01T00:00:00Z',
    endsAt: '2027-02-02T00:00:00Z',
    label: 'Winter transfer window',
    sourceNote: TRANSFER_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'transfer-deadline-winter-2027',
    eventType: 'transfer-deadline',
    flagshipId: 'transfer-window-challenge',
    startsAt: '2027-01-25T00:00:00Z',
    endsAt: '2027-02-03T00:00:00Z',
    label: 'Winter deadline day',
    sourceNote: TRANSFER_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-matchday-7-2027',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2027-01-17T00:00:00Z',
    endsAt: '2027-01-24T00:00:00Z',
    label: 'Champions League matchday 7',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-matchday-8-2027',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2027-01-25T00:00:00Z',
    endsAt: '2027-01-31T00:00:00Z',
    label: 'Champions League matchday 8',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-knockout-playoffs-2027',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2027-02-14T00:00:00Z',
    endsAt: '2027-02-28T00:00:00Z',
    label: 'Champions League knockout play-offs',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'international-break-march-2027',
    eventType: 'international-break',
    flagshipId: 'world-xi-cup',
    startsAt: '2027-03-19T00:00:00Z',
    endsAt: '2027-03-31T00:00:00Z',
    label: 'International window',
    sourceNote: FIFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-round-of-16-2027',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2027-03-07T00:00:00Z',
    endsAt: '2027-03-20T00:00:00Z',
    label: 'Champions League round of 16',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-quarter-finals-2027',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2027-04-04T00:00:00Z',
    endsAt: '2027-04-17T00:00:00Z',
    label: 'Champions League quarter-finals',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-semi-finals-2027',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2027-04-25T00:00:00Z',
    endsAt: '2027-05-08T00:00:00Z',
    label: 'Champions League semi-finals',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
  {
    id: 'champions-league-final-2027',
    eventType: 'champions-league',
    flagshipId: 'champions-xi',
    startsAt: '2027-06-03T00:00:00Z',
    endsAt: '2027-06-07T00:00:00Z',
    label: 'Champions League final',
    sourceNote: UEFA_SOURCE,
    lastVerifiedAt: '2026-08-29',
    enabled: true,
  },
];
